<script setup lang="ts">
import { useFormValidation } from '../../../../../composables/useFormValidation'
import { required } from '../../../../../utils/validation'
import TextInput from '../../../../../components/ui/form/TextInput.vue'
import CheckInput from '../../../../../components/ui/form/CheckInput.vue'
import { api } from '../../../../../api/Api'
import Toast from '../../../../../services/Toast'
import { Permission } from '../../../../../types/auth'
import { ref, onMounted } from 'vue'
import ModalFormTemplate from '../../../../../components/ui/Templates/ModalFormTemplate.vue'

const props = defineProps<{
  data?: any | null
  mode: 'create' | 'edit' | 'view' | 'showQuickView' | 'toggleStatus'
  title: string | null
  endPoint: string,
  permissions?: Permission[],
  warehouse?: any
  listCreateName?: string
}>()

const emit = defineEmits<{
  (e: 'save', data: any): void
  (e: 'close'): void
}>()

const { fields, formData, setFieldRules, validateForm, resetForm, setFormData } = useFormValidation({
  id: props.data?.id || "",
    code: props.data?.code || "",
    name: props.data?.name || "",
    warehouses_id: props.data?.warehouses_id || props.warehouse?.id || "",
    warehouse: props.data?.warehouse || props.warehouse?.name || "",
    active: props.data?.active || true,
    uid: props.data?.uid || "",
  });

setFieldRules("warehouses_id", [required("Warehouse is required")]);
setFieldRules("code", [required("Code is required")]);
setFieldRules("name", [required("Name is required")]);


const handleSubmit = async (close: boolean, newRecord: boolean) => {
  if (validateForm()) {
    const action = formData.value.uid != '' ? 'update' : 'create'
    const response = await api.post((props.endPoint.slice(-1) == '-' ? props.endPoint : props.endPoint + '-') + action, formData.value)
    if (response.success == true) {
      Toast.show('saved successfully')
      emit('save', response.data)
      if (close) {
        emit('close')
      } else if (newRecord) {
        resetForm()
      } else {
        setFormData(response.data)        
      }
    }
  }
}

const isReadOnly = ref(true);
onMounted(() => {
  isReadOnly.value = props.mode == 'view'
  if (props.mode == 'create') {
      resetForm()
    } else if (props.data) {
      setFormData(props.data)
    }
})


</script>
<template>
  <ModalFormTemplate :data="data" :mode="mode" :title="title" :endPoint="endPoint" :perm="permissions"
    :listCreateName="listCreateName" :tabList="[]" :formData="formData" @save="handleSubmit"
    @close="$emit('close')">
    <template #form>
      <div class="grid md:grid-cols-2 gap-6">
        <TextInput
          v-model="fields.warehouse.value"
          label="Warhouse"
          :readonly="true"
          :error="
            fields.warehouses_id.touched ? fields.warehouses_id.error : null
          "
          @blur="fields.warehouses_id.touched = true"
        />
      </div>
      <div class="grid md:grid-cols-2 gap-6">
        <TextInput
          v-model="fields.code.value"
          label="Code"
          :readonly="isReadOnly"
          :error="fields.code.touched ? fields.code.error : null"
          @blur="fields.code.touched = true"
        />

        <TextInput
          v-model="fields.name.value"
          label="Name"
          :readonly="isReadOnly"
          :error="fields.name.touched ? fields.name.error : null"
          @blur="fields.name.touched = true"
        />
        <CheckInput
          v-model="fields.active.value"
          :readonly="isReadOnly"
          label="Active"
          :error="fields.active.touched ? fields.active.error : null"
          @blur="fields.active.touched = true"
        />
      </div>
    </template>
  </ModalFormTemplate>
</template>